// extracted by mini-css-extract-plugin
export default {"heading":"style_heading__bC9vi","heading_dark":"style_heading_dark__9MDPC","heading_light":"style_heading_light__yJIie"};